import { render, staticRenderFns } from "./IdeaCoachSelection.vue?vue&type=template&id=8940da6a&scoped=true&"
import script from "./IdeaCoachSelection.vue?vue&type=script&lang=js&"
export * from "./IdeaCoachSelection.vue?vue&type=script&lang=js&"
import style0 from "./IdeaCoachSelection.vue?vue&type=style&index=0&id=8940da6a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8940da6a",
  null
  
)

export default component.exports